import { render, staticRenderFns } from "./designDrawing.vue?vue&type=template&id=02f4bb12&scoped=true&"
import script from "./designDrawing.vue?vue&type=script&lang=js&"
export * from "./designDrawing.vue?vue&type=script&lang=js&"
import style0 from "./designDrawing.vue?vue&type=style&index=0&id=02f4bb12&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f4bb12",
  null
  
)

export default component.exports